import React from "react";
const FormUnit = (props) => {
    return (
        <div className="form-unit">
            <style jsx>{`
                .form-unit {
                    box-sizing: border-box;
                    ${props.margin === false ? '' : `
                    margin-top: 3px;
                    width: 100%;
                    `}
                }
            `}</style>
            {props.children}
        </div>
    )
}

export default FormUnit;
